/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Awaiting_Run_Approval_LinkInputs */



/**
* | output |
* | --- |
* | "Open the run" |
*
* @param {Chat_Awaiting_Run_Approval_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_awaiting_run_approval_link = /** @type {((inputs?: Chat_Awaiting_Run_Approval_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Awaiting_Run_Approval_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lauf öffnen")
	return /** @type {LocalizedString} */ ("Open the run")
});